
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Image} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import dayjs from 'dayjs';
const dateFormat = 'DD/MM/YYYY';

/*
 <Form.Field  required  error={errors.templateForm}>            
                              <label  >{strings?strings["templateForm"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["templateForm"]:""} 
                                    name="templateForm"
                                    onChange={onChange}
                                    value={datos.templateForm}
                                    icon='edit'/>
                            </Form.Field>
*/

const CursoConstanciaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, fechas, cursoCombo, deleteImagen, onHandleFile, imgFondo, deleteImagenFirma, onHandleFileFirma})=>{

    //console.log(datos);

	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["CursoConstancia"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                           <Form.Field  required  error={errors.cursoId}>
                              <label  >{strings?strings["cursoId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["cursoId"]:""} 
                                    name="cursoId"
								    fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.cursoId}
                                    options={cursoCombo}/>
                            </Form.Field>
        
        
                            <Form.Field  >
                            <label>{strings?strings["imgFondo"]:""} </label>
                             <Input placeholder='imgFondo'
                                onChange={onHandleFile}
                                name="imgFondo"
                                type='file'

                            />        
                            </Form.Field>
        
                            {datos.imagenFondo!=null?    
                                <>
                                <Image  src={datos.imagenFondo} />    

                                <Button style={{background: '#255b4d' , color:"white"}} onClick={deleteImagen}>
                                    Borrar imagen
                                </Button>
                                </>
                            :
                    
                                ""
        
                            }
        
                            <br/>
        
                            <Form.Field  required  error={errors.texto1}>            
                              <label  >{strings?strings["texto1"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["texto1"]:""} 
                                    name="texto1"
                                    onChange={onChange}
                                    value={datos.texto1}
                                    icon='edit'/>
                            </Form.Field>
        
        
                            <Form.Field  required  error={errors.constanciaDiploma}>            
                              <label  >{strings?strings["constanciaDiploma"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["constanciaDiploma"]:""} 
                                    name="constanciaDiploma"
                                    onChange={onChange}
                                    value={datos.constanciaDiploma}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.texto2}>            
                              <label  >{strings?strings["texto2"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["texto2"]:""} 
                                    name="texto2"
                                    onChange={onChange}
                                    value={datos.texto2}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.texto3}>            
                              <label  >{strings?strings["texto3"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["texto3"]:""} 
                                    name="texto3"
                                    onChange={onChange}
                                    value={datos.texto3}
                                    icon='edit'/>
                            </Form.Field>
                        
                            <Form.Field  required  error={errors.texto4}>            
                              <label  >{strings?strings["texto4"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["texto4"]:""} 
                                    name="texto4"
                                    onChange={onChange}
                                    value={datos.texto4}
                                    icon='edit'/>
                            </Form.Field>
                            
                            <Form.Field required>
                                <label  >Fecha de inicio del curso</label>  
                                <DatePicker bordered={false}
                                        defaultValue={dayjs(datos.fecha, dateFormat)}    
                                        onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                        locale={locale} 
                                        size="large" 
                                        value={dayjs(datos.fecha, dateFormat)}
                                        format={dateFormat} />
                            </Form.Field>                                              

                                            
                            <Form.Field  required  error={errors.imgFirma}>            
                              <label  >{strings?strings["imgFirma"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["imgFirma"]:""} 
                                    name="imgFirma"
                                    onChange={onChange}
                                    value={datos.imgFirma}
                                    icon='edit'/>
                            </Form.Field>
                                    
                                    
                             <Form.Field  >
                            <label>{strings?strings["imgFirma"]:""} </label>
                             <Input placeholder='imgFirma'
                                onChange={onHandleFileFirma}
                                name="imgFirma"
                                type='file'

                            />        
                            </Form.Field>
        
                            {datos.imagenFirma!=null?    
                                <>
                                <Image  src={datos.imagenFirma} />    

                                <Button style={{background: '#255b4d' , color:"white"}} onClick={deleteImagenFirma}>
                                    Borrar imagen
                                </Button>
                                </>
                            :
                    
                                ""
        
                            }
        
                            <br/>        
                                    
                                    
                                    
                                            
                            <Form.Field  required  error={errors.nombreFirma}>            
                              <label  >{strings?strings["nombreFirma"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nombreFirma"]:""} 
                                    name="nombreFirma"
                                    onChange={onChange}
                                    value={datos.nombreFirma}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.puestoFirma}>            
                              <label  >{strings?strings["puestoFirma"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["puestoFirma"]:""} 
                                    name="puestoFirma"
                                    onChange={onChange}
                                    value={datos.puestoFirma}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.empresaFirma}>            
                              <label  >{strings?strings["empresaFirma"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["empresaFirma"]:""} 
                                    name="empresaFirma"
                                    onChange={onChange}
                                    value={datos.empresaFirma}
                                    icon='edit'/>
                            </Form.Field>
                                            
                           
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/cursoconstancias">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CursoConstanciaForm;